import React from 'react'
import {Col} from 'reactstrap'
import {ControllerAlarm} from './'

import PauseIcon from 'react-icons/lib/fa/pause'
import PlayIcon from 'react-icons/lib/fa/play'
import PowerIcon from 'react-icons/lib/fa/power-off'
import SetpointIcon from 'react-icons/lib/fa/bullseye'
import ServiceDisabledIcon from 'react-icons/lib/fa/times-circle'
import WarningIcon from 'react-icons/lib/fa/exclamation-triangle'
import ConnectionIcon from 'react-icons/lib/fa/wifi'
import ArchivedIcon from 'react-icons/lib/fa/archive'
import ChemicalIcon from 'react-icons/lib/fa/flask'
import ManualIcon from 'react-icons/lib/fa/hand-paper-o'
import LegacyIcon from 'react-icons/lib/fa/history'
import WaterIcon from 'react-icons/lib/io/waterdrop'
import StarIcon from 'react-icons/lib/fa/star'

let ControllerAlarmPanel = ({controller}) =>
    <Col xs={12} className="alarm-panel text-left">
        {controller.running && !controller.archived ?
            <ControllerAlarm colorClass="bg-success">
                <PlayIcon className="mr-2"/>
                Running
            </ControllerAlarm>:
            <ControllerAlarm colorClass="bg-danger"
                               value={controller.stopReason && controller.stopReason.length ? controller.stopReason : null}>
                <PauseIcon className="mr-2"/>
                Stopped
            </ControllerAlarm>}

        {controller.powerLoss && !controller.archived ?
            <ControllerAlarm colorClass="bg-danger"
                               value="OFF"
                               valueClass="font-weight-bold">
                <PowerIcon className="mr-2"/>
                Power
            </ControllerAlarm>:
            (!controller.archived ?
                <ControllerAlarm colorClass="bg-success"
                                 value="ON"
                                 valueClass="font-weight-bold">
                    <PowerIcon className="mr-2"/>
                    Power
                </ControllerAlarm>: null)}

        {controller.archived ?
            <ControllerAlarm colorClass="bg-secondary"
                             value="Archived">
                <ArchivedIcon/>
            </ControllerAlarm>:
                (controller.online ?
                    <ControllerAlarm colorClass="bg-success">
                        <ConnectionIcon className="mr-2"/>
                        Online
                    </ControllerAlarm>:
                    <ControllerAlarm colorClass="bg-warning"
                                     dark={true}>
                        <ConnectionIcon className="mr-2"/>
                        Offline
                    </ControllerAlarm>)}

        {controller.chemicalRateSetpoint ?
            <ControllerAlarm colorClass="bg-primary"
                               value={`${controller.chemicalRateSetpoint} ${controller.flowUnits}`}>
                <SetpointIcon className="mr-2"/>
                Rate&nbsp;Setpoint
            </ControllerAlarm>:
                null}

        {controller.getLatestStatusValue('irrigation_kill') ?
            <ControllerAlarm colorClass="bg-primary"
                             valueClass="font-weight-bold"
                             value={"ON"}>
                <WaterIcon className="mr-2"/>
                Irrigation&nbsp;Kill
            </ControllerAlarm>:
                null}

        {controller.currentChemical ?
            <ControllerAlarm colorClass="bg-primary"
                             valueClass="font-weight-bold"
                             value={controller.currentChemical}>
                <ChemicalIcon className="mr-2"/>
                Chemical
            </ControllerAlarm>:
            null}

        {controller.getLatestStatusValue('aux_digital_input') ?
            <ControllerAlarm colorClass="bg-secondary"
                             value={controller.getLatestStatusValue('aux_digital_input')}>
                <StarIcon className={"mr-2"}/>
                Aux&nbsp;Input
            </ControllerAlarm>:
            null}

        {controller.getLatestStatusValue('aux_pressure') ?
            <ControllerAlarm colorClass="bg-secondary d-inline-block"
                             value={`${controller.getLatestStatusValue('aux_pressure')} PSI`}>
                <StarIcon className={"mr-2"}/>
                Aux&nbsp;Pressure
            </ControllerAlarm>:
            null}

        {!controller.autoManMode ?
            <ControllerAlarm colorClass="bg-danger"
                               value="Manual Control">
                <ManualIcon/>
            </ControllerAlarm>:
            null}

        {!controller.cellServiceActive ?
            <ControllerAlarm colorClass="bg-danger"
                             value="Cell Service Disabled">
                <ServiceDisabledIcon/>
            </ControllerAlarm>:
            null}

        {controller.legacyAccess ?
            <ControllerAlarm colorClass="bg-warning"
                             dark={true}>
                <LegacyIcon className="mr-2"/>
                Legacy&nbsp;Software
            </ControllerAlarm>:
            null}

        {controller.memoryError ?
            <ControllerAlarm colorClass="bg-warning"
                              pulse={true}
                              value="Memory Error">
                <WarningIcon/>
            </ControllerAlarm>:
            null}

        {controller.USBError ?
            <ControllerAlarm colorClass="bg-warning"
                             pulse={true}
                             value="USB Error">
                <WarningIcon/>
            </ControllerAlarm>:
            null}

        {controller.clockErrorActive ?
            <ControllerAlarm colorClass="bg-warning"
                             pulse={true}
                             value="Clock Error">
                <WarningIcon/>
            </ControllerAlarm>:
            null}

 	{controller.batteryErrorActive ?
            <ControllerAlarm colorClass="bg-warning"
                             pulse={true}
                             value="Battery Error">
                <WarningIcon/>
            </ControllerAlarm>:
            null}

	{controller.tankIsLow ?
            <ControllerAlarm colorClass="bg-warning"
                             pulse={true}
                             value="Low Tank Level">
                <WarningIcon/>
            </ControllerAlarm>:
            null}

        {controller.tankTooLowForBatch ?
            <ControllerAlarm colorClass="bg-warning"
                             pulse={true}
                             value="Tank Too Low For Batch">
                <WarningIcon/>
            </ControllerAlarm>:
            null}

    </Col>

export default ControllerAlarmPanel



// WEBPACK FOOTER //
// ./src/components/ui/ControllerAlarmPanel.js